<template>
    <div>
  <v-tooltip
    color="pink"
    right>
    <template v-slot:activator="{ on }">
      <v-fab-transition>
        <v-btn
          v-show="show"
          :to="{ name: 'Send' }"
          absolute
          color="pink"
          fab
          bottom
          left
          large
          v-on="on"
        >
          <v-icon>mdi-message-plus</v-icon>
        </v-btn>
      </v-fab-transition>
    </template>
    <span>Send an SMS alert</span>
  </v-tooltip>
  </div>
</template>

<script>
export default {
  name: 'SendButton',
  components: {
  },
  props: {
    show: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
  }),
  methods: {
  }
}
</script>
